import styled from 'styled-components';

export const BottomNav = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;

  .bottom-nav__link {
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
    flex: 1;
    text-decoration: none;
    height: 100%;
    justify-content: center;
  }

  svg {
    width: 32px;
    height: 32px;
    margin-bottom: 3px;
  }

  svg path {
    fill: ${({ theme }) => theme.footer.link};
  }

  .active svg path,
  .active:visited svg path {
    fill: ${({ theme }) => theme.footer.activeLink};
  }
`;
